(function () {
  const getVendorCollectionQ = (root) => {
    if (!root) {
      return '';
    }

    const fromData = root.getAttribute('data-vendor-q');

    if (fromData) {
      return fromData;
    }

    try {
      const params = new URLSearchParams(window.location.search);
      const fromUrl = params.get('q');

      if (fromUrl) {
        return fromUrl;
      }

      const stored = sessionStorage.getItem('collectionVendorQ');

      if (stored) {
        return stored;
      }
    } catch (error) {
      return '';
    }

    return '';
  };

  const persistVendorCollectionQ = (root) => {
    if (!root || root.getAttribute('data-collection-handle') !== 'vendors') {
      return;
    }

    const vendorQ = getVendorCollectionQ(root);

    if (!vendorQ) {
      return;
    }

    root.setAttribute('data-vendor-q', vendorQ);

    try {
      sessionStorage.setItem('collectionVendorQ', vendorQ);
    } catch (error) {}
  };

  const prepareCollectionGetForm = (form, root) => {
    if (!form || form.method.toLowerCase() !== 'get') {
      return;
    }

    form.querySelectorAll('input[type="number"]').forEach((input) => {
      if (input.value === '') {
        input.removeAttribute('name');
      }
    });

    if (!root || root.getAttribute('data-collection-handle') !== 'vendors') {
      return;
    }

    const vendorQ = getVendorCollectionQ(root);

    if (!vendorQ) {
      return;
    }

    let qInput = form.querySelector('input[name="q"]');

    if (!qInput) {
      qInput = document.createElement('input');
      qInput.type = 'hidden';
      qInput.name = 'q';
      form.appendChild(qInput);
    }

    qInput.value = vendorQ;
  };

  const initCollectionVendorForms = () => {
    const root = document.querySelector('[data-collection-page]');

    if (!root || root.dataset.collectionVendorFormsInitialized === 'true') {
      return;
    }

    persistVendorCollectionQ(root);

    document.querySelectorAll('[data-collection-filters-form], .collection-products__sort').forEach((form) => {
      form.addEventListener('submit', () => {
        prepareCollectionGetForm(form, root);
      });
    });

    root.dataset.collectionVendorFormsInitialized = 'true';
  };

  const initCollectionSort = () => {
    document.querySelectorAll('[data-collection-sort]').forEach((select) => {
      if (select.dataset.collectionSortInitialized === 'true') {
        return;
      }

      select.addEventListener('change', () => {
        const form = select.closest('form');
        const root = document.querySelector('[data-collection-page]');

        if (form) {
          prepareCollectionGetForm(form, root);
          form.submit();
        }
      });

      select.dataset.collectionSortInitialized = 'true';
    });
  };

  const COLLECTION_FILTERS_DESKTOP_MQ = window.matchMedia('(min-width: 1200px)');

  const getCollectionPageRoot = () =>
    document.querySelector('[data-collection-page]') || document.querySelector('[data-search-page]');

  const setCollectionFiltersDrawerOpen = (pageRoot, isOpen) => {
    if (!pageRoot || COLLECTION_FILTERS_DESKTOP_MQ.matches) {
      return;
    }

    const filtersRoot = pageRoot.querySelector('[data-collection-filters]');
    const openButtons = pageRoot.querySelectorAll('[data-collection-filters-open]');

    pageRoot.classList.toggle('is-collection-filters-open', isOpen);
    document.documentElement.classList.toggle('is-collection-filters-locked', isOpen);

    if (filtersRoot) {
      filtersRoot.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    }

    openButtons.forEach((button) => {
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  };

  const syncCollectionFiltersDrawerMode = () => {
    const pageRoot = getCollectionPageRoot();
    const filtersRoot = pageRoot ? pageRoot.querySelector('[data-collection-filters]') : null;

    if (!pageRoot || !filtersRoot) {
      return;
    }

    if (COLLECTION_FILTERS_DESKTOP_MQ.matches) {
      setCollectionFiltersDrawerOpen(pageRoot, false);
      filtersRoot.removeAttribute('aria-hidden');
      return;
    }

    if (!pageRoot.classList.contains('is-collection-filters-open')) {
      filtersRoot.setAttribute('aria-hidden', 'true');
    }
  };

  const initCollectionFiltersDrawer = () => {
    const pageRoot = getCollectionPageRoot();

    if (!pageRoot || pageRoot.dataset.collectionFiltersDrawerInitialized === 'true') {
      return;
    }

    pageRoot.querySelectorAll('[data-collection-filters-open]').forEach((button) => {
      button.addEventListener('click', () => {
        setCollectionFiltersDrawerOpen(pageRoot, true);
      });
    });

    pageRoot.querySelectorAll('[data-collection-filters-close]').forEach((control) => {
      control.addEventListener('click', () => {
        setCollectionFiltersDrawerOpen(pageRoot, false);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') {
        return;
      }

      if (pageRoot.classList.contains('is-collection-filters-open')) {
        setCollectionFiltersDrawerOpen(pageRoot, false);
      }
    });

    if (typeof COLLECTION_FILTERS_DESKTOP_MQ.addEventListener === 'function') {
      COLLECTION_FILTERS_DESKTOP_MQ.addEventListener('change', syncCollectionFiltersDrawerMode);
    } else if (typeof COLLECTION_FILTERS_DESKTOP_MQ.addListener === 'function') {
      COLLECTION_FILTERS_DESKTOP_MQ.addListener(syncCollectionFiltersDrawerMode);
    }

    syncCollectionFiltersDrawerMode();
    pageRoot.dataset.collectionFiltersDrawerInitialized = 'true';
  };

  const initCollectionFilters = () => {
    document.querySelectorAll('[data-collection-filters]').forEach((root) => {
      if (root.dataset.collectionFiltersInitialized === 'true') {
        return;
      }

      root.querySelectorAll('[data-collection-filter-toggle]').forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const group = toggle.closest('.collection-filters__group');
          const content = group ? group.querySelector('[data-collection-filter-content]') : null;
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

          toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');

          if (content) {
            content.hidden = isExpanded;
          }

          if (group) {
            group.classList.toggle('is-collapsed', isExpanded);
          }
        });
      });

      root.dataset.collectionFiltersInitialized = 'true';
    });
  };

  const COLLECTION_SCROLL_OFFSET = 120;

  const getPageFromUrl = (urlString) => {
    try {
      const url = new URL(urlString, window.location.origin);
      const page = Number.parseInt(url.searchParams.get('page') || '1', 10);

      if (!Number.isFinite(page) || page < 1) {
        return 1;
      }

      return page;
    } catch (error) {
      return 1;
    }
  };

  const buildUrlWithPage = (page, baseHref) => {
    const url = new URL(baseHref || window.location.href, window.location.origin);

    if (page <= 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', String(page));
    }

    return url.pathname + url.search + url.hash;
  };

  const updateUrlPage = (page, usePush) => {
    const nextPath = buildUrlWithPage(page);
    const currentPath = window.location.pathname + window.location.search + window.location.hash;

    if (nextPath === currentPath) {
      return;
    }

    const state = { collectionPage: page };

    if (usePush) {
      history.pushState(state, '', nextPath);
    } else {
      history.replaceState(state, '', nextPath);
    }
  };

  const getMaxLoadedPage = (productsRoot) => {
    const fromData = Number.parseInt(productsRoot.getAttribute('data-max-loaded-page') || '', 10);

    if (Number.isFinite(fromData) && fromData > 0) {
      return fromData;
    }

    const initial = Number.parseInt(productsRoot.getAttribute('data-initial-page') || '1', 10);

    if (Number.isFinite(initial) && initial > 0) {
      return initial;
    }

    return 1;
  };

  const setMaxLoadedPage = (productsRoot, page) => {
    productsRoot.setAttribute('data-max-loaded-page', String(page));
  };

  const getActivePageFromScroll = (grid, maxLoadedPage) => {
    const pageFirstTops = new Map();

    grid.querySelectorAll('.product-card[data-load-page]').forEach((card) => {
      const page = Number.parseInt(card.getAttribute('data-load-page') || '', 10);

      if (!Number.isFinite(page) || page < 1) {
        return;
      }

      const top = card.getBoundingClientRect().top + window.scrollY;

      if (!pageFirstTops.has(page) || top < pageFirstTops.get(page)) {
        pageFirstTops.set(page, top);
      }
    });

    const pages = Array.from(pageFirstTops.keys()).sort((a, b) => a - b);

    if (pages.length === 0) {
      return 1;
    }

    const scrollLine = window.scrollY + COLLECTION_SCROLL_OFFSET;
    let activePage = pages[0];

    pages.forEach((page) => {
      if (pageFirstTops.get(page) <= scrollLine) {
        activePage = page;
      }
    });

    if (activePage > maxLoadedPage) {
      return maxLoadedPage;
    }

    return activePage;
  };

  const collectVariantIds = (grid) => {
    const ids = new Set();

    grid.querySelectorAll('.product-card[data-variant-id]').forEach((card) => {
      const variantId = card.getAttribute('data-variant-id');

      if (variantId) {
        ids.add(variantId);
      }
    });

    return ids;
  };

  const afterCollectionProductsAppend = (grid) => {
    if (typeof window.bindAjaxCartForms === 'function') {
      window.bindAjaxCartForms(grid);
    }

    if (typeof window.initRenkVaryantSwatches === 'function') {
      window.initRenkVaryantSwatches();
    } else {
      document.dispatchEvent(new CustomEvent('renk-varyant:catalog-ready'));
    }

    document.dispatchEvent(new Event('shopify:section:load'));
  };

  const initCollectionLoadMore = () => {
    const productsRoot = document.querySelector('[data-collection-products][data-initial-page]');

    if (!productsRoot) {
      return;
    }

    const grid = productsRoot.querySelector('.collection-products__grid');

    if (!grid) {
      return;
    }

    const initialPage = Number.parseInt(productsRoot.getAttribute('data-initial-page') || '1', 10);
    let maxLoadedPage = getMaxLoadedPage(productsRoot);

    if (initialPage > maxLoadedPage) {
      maxLoadedPage = initialPage;
      setMaxLoadedPage(productsRoot, maxLoadedPage);
    }

    updateUrlPage(getPageFromUrl(window.location.href), false);

    if (productsRoot.dataset.collectionLoadMoreScrollInitialized !== 'true') {
      let scrollRaf = null;

      const syncUrlToScroll = () => {
        const currentMax = getMaxLoadedPage(productsRoot);
        const activePage = getActivePageFromScroll(grid, currentMax);
        updateUrlPage(activePage, false);
      };

      window.addEventListener('scroll', () => {
        if (scrollRaf) {
          return;
        }

        scrollRaf = window.requestAnimationFrame(() => {
          scrollRaf = null;
          syncUrlToScroll();
        });
      }, { passive: true });

      productsRoot.dataset.collectionLoadMoreScrollInitialized = 'true';
    }

    document.querySelectorAll('[data-collection-load-more]').forEach((button) => {
      if (button.dataset.collectionLoadMoreInitialized === 'true') {
        return;
      }

      button.addEventListener('click', () => {
        if (button.disabled) {
          return;
        }

        const nextUrl = button.getAttribute('data-next-url');

        if (!nextUrl) {
          return;
        }

        const loadMoreRoot = button.closest('[data-collection-load-more-root]');
        const defaultLabel = button.textContent.trim();
        const loadingLabel = button.getAttribute('data-loading-text') || defaultLabel;
        const errorLabel = button.getAttribute('data-error-text') || defaultLabel;
        const nextPage = getPageFromUrl(nextUrl);

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = loadingLabel;

        fetch(nextUrl, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) {
              throw new Error('load_failed');
            }

            return response.text();
          })
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const nextGrid = doc.querySelector('[data-collection-products] .collection-products__grid');

            if (!nextGrid) {
              throw new Error('load_failed');
            }

            const existingIds = collectVariantIds(grid);

            nextGrid.querySelectorAll(':scope > .product-card').forEach((sourceCard) => {
              const variantId = sourceCard.getAttribute('data-variant-id');

              if (variantId && existingIds.has(variantId)) {
                return;
              }

              const card = document.importNode(sourceCard, true);

              if (!card.getAttribute('data-load-page')) {
                card.setAttribute('data-load-page', String(nextPage));
              }

              grid.appendChild(card);

              if (variantId) {
                existingIds.add(variantId);
              }
            });

            document.dispatchEvent(
              new CustomEvent('joker:datalayer-list-updated', {
                bubbles: true,
                detail: {
                  listRoot: grid,
                },
              })
            );

            maxLoadedPage = Math.max(getMaxLoadedPage(productsRoot), nextPage);
            setMaxLoadedPage(productsRoot, maxLoadedPage);
            updateUrlPage(maxLoadedPage, true);

            const fetchedButton = doc.querySelector('[data-collection-load-more]');
            const fetchedLoadMoreRoot = doc.querySelector('[data-collection-load-more-root]');

            if (fetchedButton && fetchedButton.getAttribute('data-next-url')) {
              button.setAttribute('data-next-url', fetchedButton.getAttribute('data-next-url'));
              button.disabled = false;
              button.removeAttribute('aria-busy');
              button.textContent = defaultLabel;
            } else {
              button.remove();
            }

            if (fetchedLoadMoreRoot && loadMoreRoot) {
              const fetchedTotal = fetchedLoadMoreRoot.querySelector('.collection-products__total-count');
              const currentTotal = loadMoreRoot.querySelector('.collection-products__total-count');

              if (fetchedTotal && currentTotal) {
                currentTotal.textContent = fetchedTotal.textContent;
              }
            }

            afterCollectionProductsAppend(grid);
          })
          .catch(() => {
            button.disabled = false;
            button.removeAttribute('aria-busy');
            button.textContent = errorLabel;
          });
      });

      button.dataset.collectionLoadMoreInitialized = 'true';
    });
  };

  const initCollectionSeo = () => {
    document.querySelectorAll('[data-collection-seo]').forEach((root) => {
      if (root.dataset.collectionSeoInitialized === 'true') {
        return;
      }

      const panel = root.querySelector('[data-collection-seo-panel]');
      const inner = root.querySelector('[data-collection-seo-inner]');
      const toggle = root.querySelector('[data-collection-seo-toggle]');
      const labelRead = root.querySelector('[data-collection-seo-label-read]');
      const labelHide = root.querySelector('[data-collection-seo-label-hide]');

      if (!panel || !inner || !toggle) {
        return;
      }

      const collapsedHeight = Number.parseInt(root.dataset.collectionSeoCollapsed, 10) || 80;

      const setCollapsed = () => {
        panel.style.maxHeight = collapsedHeight + 'px';
        root.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');

        if (labelRead) {
          labelRead.hidden = false;
        }

        if (labelHide) {
          labelHide.hidden = true;
        }
      };

      const setExpanded = () => {
        panel.style.maxHeight = inner.scrollHeight + 'px';
        root.classList.add('is-expanded');
        toggle.setAttribute('aria-expanded', 'true');

        if (labelRead) {
          labelRead.hidden = true;
        }

        if (labelHide) {
          labelHide.hidden = false;
        }
      };

      const syncExpandedHeight = () => {
        if (root.classList.contains('is-expanded')) {
          panel.style.maxHeight = inner.scrollHeight + 'px';
        }
      };

      const evaluate = () => {
        panel.style.maxHeight = 'none';
        const fullHeight = inner.scrollHeight;
        panel.style.maxHeight = '';

        if (fullHeight <= collapsedHeight + 1) {
          root.classList.add('is-short');
          panel.style.maxHeight = 'none';
          toggle.hidden = true;
          return;
        }

        root.classList.remove('is-short');
        toggle.hidden = false;
        setCollapsed();
      };

      toggle.addEventListener('click', () => {
        if (root.classList.contains('is-expanded')) {
          setCollapsed();
          return;
        }

        setExpanded();
      });

      window.addEventListener('resize', syncExpandedHeight);
      evaluate();

      root.dataset.collectionSeoInitialized = 'true';
    });
  };

  const initCollectionPage = () => {
    initCollectionVendorForms();
    initCollectionSort();
    initCollectionFilters();
    initCollectionFiltersDrawer();
    initCollectionLoadMore();
    initCollectionSeo();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionPage);
  } else {
    initCollectionPage();
  }

  document.addEventListener('shopify:section:load', initCollectionPage);
})();
